(function () {

    "use strict";

    function aplicacionController(usersStore, $sce, $interval) {
        var vm = this;

        vm.$onInit = function () {
            CargarFormulario();
        };

        vm.$onChanges = function () {
            CargarFormulario();
        };

        vm.iframeLoadedCallBack = function () {
            vm.cargando = false;
            $interval(function () {
                vm.cargando = false;
            }, 1000);
        };

        function CargarFormulario() {
            vm.cargando = true;

            switch (vm.referenciaFormulario)
            {
                case "solicitud":
                    usersStore.getLoggedUserData()
                        .then(function (user)
                        {
                        /*dividir par�metro user.position */
                            var cadenaADividir = user.position;
                            var arrayDeCadenas = cadenaADividir.split("#");
                            var nombredistri = arrayDeCadenas[0];
                            var tipodistri = arrayDeCadenas[1];
                            var permiso = arrayDeCadenas[2];


                        /*  var src = "https://services.cognitoforms.com/f/zfR4UIOLNEuM9xSYGYHM2w?id=11&mailsolicitante=" + user.email;*/
                        /*    var src = "https://www.cognitoforms.com/KDES/BASE?Entry={Solicitante:{CodigoDistribuidor:" + user.department + ",TipoDistri:'" + user.position + "',MailSolicitante:'" + user.email + "'}}"; */

                            var src = "https://www.cognitoforms.com/KDES/BASE?Entry={Solicitante:{CodigoDistribuidor:" + user.department + ",NombreDistribuidor:'" + nombredistri + "',TipoDistri:'" + tipodistri + "',MailSolicitante:'" + user.email + "'}}";
                            vm.url = $sce.trustAsResourceUrl(src);
                        });
                    break;

                case "central":
                    var src = "https://services.cognitoforms.com/f/zfR4UIOLNEuM9xSYGYHM2w?id=27";
                    vm.url = $sce.trustAsResourceUrl(src);     
                    break;

                case "bomba":
                    var src = "https://www.cognitoforms.com/KDES/BASE";
                    vm.url = $sce.trustAsResourceUrl(src);
                    break;

                case "elpais":
                    var src = "https://elpais.com/";
                    vm.url = $sce.trustAsResourceUrl(src);
                    break;

                default:
                    var src = "https://forococheselectricos.com/";
                    vm.url = $sce.trustAsResourceUrl(src);
                    break;
            }
        }

    }

    aplicacionController.$inject = ["sphForms.usersStore", "$sce", "$interval"];

    angular.module("sphforms.formacion")
        .component("sphformsAplicacion", {
            controller: aplicacionController,
            bindings: {
                idEntity: "<",
                referenciaFormulario: "<"
            },
            templateUrl: "modules/formacion/components/aplicacion/aplicacion.template.html"
        });

}());
